import { ChangeDetectionStrategy, Component, inject, input, OnInit, output, signal } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { PriceLevels } from '../../../models/price-levels';
import { SeatMapService } from '../seat-map.service';
import { MatDivider } from '@angular/material/divider';
import { TranslateLangPipe } from '../../../pipe/translate-lang.pipe';

@Component({
    selector: 'lib-filter-by-price-level-seat-map',
    templateUrl: './filter-by-price-level-seat-map.component.html',
    styleUrls: ['./filter-by-price-level-seat-map.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatCheckboxModule, MatButtonModule, MatIconModule, CurrencyPipe, MatDivider, TranslateLangPipe],
})
export class FilterByPriceLevelSeatMapComponent implements OnInit {
    private readonly seatMapService = inject(SeatMapService);

    readonly priceLevels = input<PriceLevels[]>([]);
    readonly legendMode = input<boolean>(false);
    readonly closed = output<void>();
    readonly overrideHaeder = input<boolean>(false);

    readonly localSelectedIds = signal<number[]>([]);
    private initialIds: number[] = [];

    ngOnInit(): void {
        const allIds = this.priceLevels().map((pl) => pl.id);
        this.initialIds = [...allIds];
        this.localSelectedIds.set([...allIds]);
        this.seatMapService.subDrawByFilterPriceLevels.next([...allIds]);
    }

    isSelected(id: number): boolean {
        return this.localSelectedIds().includes(id);
    }

    onToggle(id: number, checked: boolean): void {
        if (checked) {
            this.localSelectedIds.update((ids) => [...ids, id]);
        } else {
            this.localSelectedIds.update((ids) => ids.filter((i) => i !== id));
        }
    }

    onApply(): void {
        this.seatMapService.subDrawByFilterPriceLevels.next([...this.localSelectedIds()]);
        this.closed.emit();
    }

    onReset(): void {
        this.localSelectedIds.set([...this.initialIds]);
        this.seatMapService.subDrawByFilterPriceLevels.next([...this.initialIds]);
    }

    onClose(): void {
        this.closed.emit();
    }
}
